
  import {
    validateName,
    
  } from "../../common/dependencies/utils/validation";
  
  export default {
    validatePopup: (params) => {
      const { reason } = params;
      let formStatus = {};
      const reasonStatus = validateName(reason,"Please Enter Reason");
      
      formStatus = {
        reason: reasonStatus.error,
       
        hasErrors: reasonStatus.hasError,
      };
      return formStatus;
    },
  
   
  };
  